import type React from "react";
import "./_form-field.scss";

interface FormFieldProps {
	label?: string;
	icon?: React.ReactNode;
	hint?: string;
	error?: string;
	children: React.ReactNode;
	className?: string;
	required?: boolean;
	rightAction?: React.ReactNode;
}

export const FormField: React.FC<FormFieldProps> = ({
	label,
	icon,
	hint,
	error,
	children,
	className = "",
	required = false,
	rightAction,
}) => {
	return (
		<div className={`form-field ${className}`}>
			{(label || rightAction) && (
				<div
					className="form-field__label-row"
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "flex-end",
					}}
				>
					<div className="form-field__label">
						<span className="form-field__label-content">
							{icon && <span className="form-field__label-icon">{icon}</span>}
							{label && label}
							{hint && <span className="form-field__hint">{hint}</span>}
							{required && <span className="form-field__required">*</span>}
						</span>
					</div>
					{rightAction && (
						<div className="form-field__right-action">{rightAction}</div>
					)}
				</div>
			)}
			<div className="form-field__control">{children}</div>
			{error && <span className="form-field__error-msg">{error}</span>}
		</div>
	);
};
